var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggles"},[_c('button',{class:_vm.viewStyle === 'tile'
        ? 'toggles__view-btn toggles__chosen'
        : 'toggles__view-btn',on:{"click":function($event){return _vm.toggleListView('tile')}}},[_c('ToggleTileView',{staticClass:"toggles__icon"})],1),_c('button',{class:_vm.viewStyle === 'list'
        ? 'toggles__view-btn toggles__chosen'
        : 'toggles__view-btn',on:{"click":function($event){return _vm.toggleListView('list')}}},[_c('ToggleListView',{staticClass:"toggles__icon"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }